<template>
    <table class="table rate-table">
        <thead>
        <tr>
            <th colspan="2">Primary renter</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td width="35%"><strong>First name:</strong></td>
            <td > {{ reservation.first_name }}</td>
        </tr>
        <tr>
            <td><strong>Last name:</strong></td>
            <td>{{ reservation.last_name }}</td>
        </tr>
        <tr>
            <td><strong>Primary Address:</strong></td>
            <td>{{ reservation.address_primary }}</td>
        </tr>
        <tr>
            <td><strong>Mobile Phone:</strong></td>
            <td>{{ reservation.phone }}</td>
        </tr>
        <tr>
            <td><strong>Email:</strong></td>
            <td>{{ reservation.email }}</td>
        </tr>
        <tr>
            <td><strong>City:</strong></td>
            <td>{{ reservation.city }}</td>
        </tr>
        <template v-if="reservation.is_international_customer || parseInt(this.$store.state.resources.config.is_international_canadian)">
            <tr>
                <td><strong>Country:</strong></td>
                <td>{{ reservation.country }}</td>
            </tr>
            <tr>
                <td><strong>Postal code:</strong></td>
                <td>{{ reservation.postal_code }}</td>
            </tr>
        </template>
        <template v-else>
            <tr>
                <td><strong>State:</strong></td>
                <td>{{ reservation.state }}</td>
            </tr>
            <tr>
                <td><strong>Zip:</strong></td>
                <td>{{ reservation.zip }}</td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "TicketInformation",
    computed: {
        reservation() {
            return this.$store.state.model.reservation;
        }
    }
}
</script>

<style scoped>

</style>
